import axios from 'axios';
import { reviveDates } from '../utils/dates';

const BASE = process.env.REACT_APP_BACKEND_URL || '';

export const TOKEN_KEY = 'currentUser';
export const getToken = () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setToken = (t) => {
    try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
    if (!t) setStoredUser(null);
};

/* Ime/e-mail ulogovanog korisnika (samo za prikaz u gornjoj traci) — preživi osvežavanje strane. */
const USER_KEY = 'tachoUser';
export const getStoredUser = () => {
    try { return JSON.parse(localStorage.getItem(USER_KEY)) || null; } catch { return null; }
};
export const setStoredUser = (u) => {
    try { u ? localStorage.setItem(USER_KEY, JSON.stringify(u)) : localStorage.removeItem(USER_KEY); } catch { /* ignore */ }
};

/* Globalni hook za toast poruke (postavlja ga AlertProvider) i za odjavu na 401. */
export const hooks = { toast: null, onUnauthorized: null };

const http = axios.create({
    baseURL: `${BASE}/API`,
    transformResponse: [(data) => {
        if (typeof data !== 'string' || !data) return data;
        try { return JSON.parse(data, reviveDates); } catch { return data; }
    }],
});

http.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

/** Tekst greške za korisnika. */
export const errorMessage = (err) => {
    if (!err.response) return 'Servis trenutno nije dostupan.';
    const d = err.response.data;
    if (typeof d === 'string' && d) return d;
    if (d && d.message) return d.message;
    return err.message;
};

http.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err.response && err.response.status;
        if (status === 401) {
            if (!err.config.url.startsWith('/users/authenticate') && hooks.onUnauthorized) hooks.onUnauthorized();
        } else if (!err.config?.silent && hooks.toast) {
            hooks.toast('error', 'Greška', errorMessage(err));
        }
        return Promise.reject(err);
    }
);

export default http;
